import { render, staticRenderFns } from "./statementAccount.vue?vue&type=template&id=5254cfc2&scoped=true&"
import script from "./statementAccount.vue?vue&type=script&lang=js&"
export * from "./statementAccount.vue?vue&type=script&lang=js&"
import style0 from "./statementAccount.vue?vue&type=style&index=0&id=5254cfc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5254cfc2",
  null
  
)

export default component.exports